/**
 * Converts common video URLs (YouTube watch/short links) to iframe-embeddable URLs.
 * YouTube blocks watch pages in iframes (X-Frame-Options: sameorigin).
 */
export function toEmbedVideoUrl(url: string): string {
  if (!url) {
    return url;
  }

  const trimmed = url.trim();

  if (trimmed.includes("youtube.com/embed/")) {
    return trimmed;
  }

  const youtubeVideoId = extractYoutubeVideoId(trimmed);
  if (youtubeVideoId) {
    return `https://www.youtube.com/embed/${youtubeVideoId}`;
  }

  return trimmed;
}

function extractYoutubeVideoId(url: string): string | null {
  const patterns = [
    /youtu\.be\/([^?&/]+)/,
    /youtube\.com\/watch\?[^#]*v=([^?&/]+)/,
    /youtube\.com\/v\/([^?&/]+)/,
    /youtube\.com\/shorts\/([^?&/]+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  return null;
}
